// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-55dK","right":"styles_right__p6pb2"};